import React from 'react'
import Logo from "../assets/logo/PNG/Paragon Yatırım_400x100 Dark mode.png"
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const Footer = () => {
    const { t } = useTranslation();

    const sponsors = [
        { id: 1, image: "https://upload.wikimedia.org/wikipedia/tr/4/47/FC_Barcelona.png", name: "Barcelona" },
        { id: 2, image: "https://upload.wikimedia.org/wikipedia/commons/5/51/Juventus_FC_2017_logo.png", name: "Juventus" },
        { id: 3, image: "https://upload.wikimedia.org/wikipedia/tr/b/b9/UEFA.png", name: "Uefa" },
        { id: 4, image: "https://www.thesportsdb.com/images/media/league/badge/7xjtuy1554397263.png", name: "Euroleague" },
        { id: 5, image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Qatar_Airways_Logo.png/1200px-Qatar_Airways_Logo.png", name: "Qatar Airways" },
        { id: 6, image: "https://cdn.worldvectorlogo.com/logos/moto-gp-logo.svg", name: "Moto GP" },
    ];

    return (
        <>
            <div className="sponsors-section pt-5">
                <div className="container position-relative">
                    <h3 className='text-center mb-5' style={{ fontSize: "32px" }}>{t('Sponsorluklarımız')}</h3>
                    <div className="slider-gradient-left"></div>
                    <div className="slider-gradient-right"></div>
                    <Swiper
                        modules={[Autoplay]}
                        spaceBetween={30}
                        slidesPerView={4}
                        loop={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 20
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 30
                            },
                            1024: {
                                slidesPerView: 5,
                                spaceBetween: 30
                            }
                        }}
                    >
                        {sponsors.map((sponsor) => (
                            <SwiperSlide key={sponsor.id}>
                                <div className="sponsor-item text-center" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '120px'  // Tüm sponsor alanları için sabit yükseklik
                                }}>
                                    <img
                                        src={sponsor.image}
                                        alt={sponsor.name}
                                        className="img-fluid"
                                        style={{
                                            maxHeight: '75px',
                                            objectFit: 'contain',
                                            width: sponsor.name === "Qatar Airways" ? '120px' : sponsor.name === "Moto GP" ? '100px' : 'auto'
                                        }}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
            <div className='footer-content'>
                <div className="container">
                    <div className='row justify-content-between'>
                        <div className="col-lg-4">
                            <img src={Logo} alt="paragon-logo" width="200px" />
                            <p className='mb-0 mt-4'>
                                {t('Paragon Yatırım - Güvenilir Stratejilerle Kazançlı Yatırımlar')}
                            </p>
                        </div>
                        <div className="col-lg-6 mt-lg-0 mt-5">
                            <div className="row">
                                <div className="col-lg-6 mb-lg-0 mb-5">
                                    <h5 className='mb-lg-5 mb-4'>{t('Faydalı Linkler')}</h5>
                                    <ul className='mb-0 list-unstyled'>
                                        <li><Link to="/">{t('Ana Sayfa')}</Link></li>
                                        <li><Link to="/about-us">{t('Hakkımızda')}</Link></li>
                                        <li><Link to="/trading-platforms">{t('İşlem Platformları')}</Link></li>
                                        <li><Link to="/investment-products">{t('Yatırım Ürünleri')}</Link></li>
                                        <li><Link to="/register">{t('Hesap Oluştur')}</Link></li>
                                    </ul>
                                </div>
                                <div className="col-lg-6">
                                    <h5 className="mb-lg-5 mb-4">{t('İletişim')}</h5>
                                    <div className='row align-items-center'>
                                        <div className="col-xl-2 col-2">
                                            <div className="icon-container">
                                                <i className="fa-solid fa-envelope fa-lg"></i>
                                            </div>
                                        </div>
                                        <div className="col-xl-10 col-10">
                                            <h6>{t('E-posta Adresi')}</h6>
                                            <a href='mailto:support@paragonyatirim.com' className="mb-0">support@paragonyatirim.com</a>
                                        </div>
                                    </div>
                                    <div className='row align-items-center mt-4'>
                                        <div className="col-xl-2 col-2">
                                            <div className="icon-container">
                                                <i className="fa-solid fa-phone fa-lg"></i>
                                            </div>
                                        </div>
                                        <div className="col-xl-10 col-10">
                                            <h6>{t('Telefon Numarası')}</h6>
                                            <a target='_blank' href='https://wa.me/447413174135' className="mb-0">+447413 174135</a>
                                        </div>
                                    </div>
                                    <div className='row align-items-center mt-4'>
                                        <div className="col-xl-2 col-2">
                                            <div className="icon-container">
                                                <i className="fa-solid fa-location-dot fa-lg"></i>
                                            </div>
                                        </div>
                                        <div className="col-xl-10 col-10">
                                            <h6>{t('Adres')}</h6>
                                            <a target='_blank' href='https://maps.app.goo.gl/SdrktzE7xVyq9Zog7' className="mb-0">{t('1 Pall Mall E, London SW1Y 5AU, United Kingdom')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright text-center">
                {t('2025 © Paragon Yatırım. Tüm hakları saklıdır.')}
            </div>
        </>
    )
}

export default Footer